import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsNeededZIndex } from '../../../../../../../redux/selector/system'
import Order from '../../../../../../Elements/modal/order/Order'
import KeyBindings from '../../../../../../Elements/keybindings'
import Button from '../../../../../../Elements/buttons/Button'
import { useTranslation } from 'react-i18next'
import CustomModal from '../../../../../../Elements/modal/CustomModal'
import { setRestaurantPaymentTypeModal, setRestaurantShowInterimOrderModal } from '../../../../../../../redux/action/restaurant'
import { ButtonsWrap } from '../../../../../../Elements/modal/order/OrderDataModal/index.styled'
import { selectRegisteredOrder } from '../../../../../../../redux/selector/restaurant'

const EVENT_Z_INDEX = 120

const RestaurantOrderDataModal = React.memo(() => {
	const order = useSelector(selectRegisteredOrder)
	const modalIsOpen = useSelector(state => state.restaurant.showInterimOrderModal)
	const isNeededZIndex = useSelector(selectIsNeededZIndex(EVENT_Z_INDEX))
	const dispatch = useDispatch()
	const { t } = useTranslation()

	const handleCloseModal = useCallback(() => {
		dispatch(setRestaurantShowInterimOrderModal(false))
		dispatch(setRestaurantPaymentTypeModal(true))
	}, [dispatch])

	return (
		<>
			<CustomModal isOpen={modalIsOpen}
									 id="order-data-modal"
									 close={handleCloseModal}
									 title={t('Filter.type.RESTAURANT')}
									 zIndex={EVENT_Z_INDEX}
									 returnZIndex={1}
									 titleUpperCase={true}
									 disableBackButton={true}
									 size="height-scroll small"
									 button={
										 <ButtonsWrap>
											 <Button icon="clear" keyButton="F3" text={t('buttons.controls.cancel_1')} onClick={handleCloseModal} className="back" />
											 <Button name="payment" icon="payment" text={t('restaurant.tables.modal.payment')} color="green"
															 keyButton="F2" zIndex={EVENT_Z_INDEX} onClick={handleCloseModal} />
										 </ButtonsWrap>
									 }>
				{order && <Order order={order} />}
			</CustomModal>

			{isNeededZIndex &&
				<KeyBindings escape={handleCloseModal} />}
		</>
	)
})

RestaurantOrderDataModal.displayName = 'RestaurantOrderDataModal'
export default RestaurantOrderDataModal
